import { ActionTypes } from './actionTypes';
import type { GeofenceTabAction } from './actions';

interface GeofenceTabState {
  showGeofences: boolean;
  showGeofencesForceVisibility: boolean;
}

const initialState: GeofenceTabState = {
  showGeofences: true,
  showGeofencesForceVisibility: false,
};

export const geofencesTabReducer = (state: GeofenceTabState = initialState, action: GeofenceTabAction): GeofenceTabState => {
  if (!(action.type in ActionTypes)) {
    return state;
  }

  switch (action.type) {
    case ActionTypes.TOGGLE_SHOW_GEOFENCES:
      return { ...state, showGeofences: !state.showGeofences };

    case ActionTypes.SHOW_GEOFENCES: {
      // avoiding unnecessary reference change if already true
      if (state.showGeofences) {
        return state;
      }
      return { ...state, showGeofences: true };
    }

    case ActionTypes.HIDE_GEOFENCES: {
      if (!state.showGeofences) return state;
      return { ...state, showGeofences: false };
    }

    case ActionTypes.TOGGLE_SHOW_GEOFENCES_FORCE_VISIBILITY: {
      return { ...state, showGeofencesForceVisibility: !state.showGeofencesForceVisibility };
    }

    case ActionTypes.SHOW_GEOFENCES_FORCE_VISIBILITY: {
      return { ...state, showGeofencesForceVisibility: true };
    }

    case ActionTypes.HIDE_GEOFENCES_FORCE_VISIBILITY: {
      return { ...state, showGeofencesForceVisibility: false };
    }

    default:
      return state;
  }
};

export { initialState as geofenceTabInitialState };
